// extracted by mini-css-extract-plugin
module.exports = {"Loader":"ShowLoader_Loader__2y5T0","TransparentBg":"ShowLoader_TransparentBg__1aYpW","GrayBg":"ShowLoader_GrayBg__17uEu"};